import { AvailabilityCalendar } from '@cian/frontend-dailyrent-calendar';
import { Button, Outside, Spinner } from '@cian/ui-kit';
import * as React from 'react';

import { BookingCalendarLayout } from 'shared/components/BookingCalendarLayout';
import * as layoutStyles from 'shared/components/BookingCalendarLayout/BookingCalendarLayout.css';

import { useBookingCalendarContainer } from './hooks';
import { BookingCalendarInput } from '../../components/BookingCalendarInput';

export const BookingCalendarInputContainer = () => {
  const {
    isOpen,
    showOverlay,
    isLoading,
    isResetDisabled,
    daysAvailability,
    value,
    tooltipMessage,
    inputText,
    isDefaultInputText,
    onSelectionChange,
    onValidationError,
    onInputClick,
    onOutsideClick,
    onResetClick,
  } = useBookingCalendarContainer();

  return (
    <Outside onOutside={onOutsideClick} active={isOpen} insideRefs={undefined}>
      <BookingCalendarLayout>
        <BookingCalendarInput
          title={inputText}
          onClick={onInputClick}
          isDefaultText={isDefaultInputText}
          isDisabled={isLoading}
        />
        {isOpen && (
          <div className={layoutStyles['dropdown']} data-testid="BookingCalendarDropdown">
            <AvailabilityCalendar
              days={daysAvailability}
              value={value}
              onChange={onSelectionChange}
              onValidationError={onValidationError}
              tooltipMessage={tooltipMessage}
            />
            {showOverlay && (
              <div className={layoutStyles['overlay']} data-testid="BookingCalendarOverlay">
                <Spinner size={24} />
              </div>
            )}
            <div className={layoutStyles['reset']}>
              <Button
                data-testid="BookingCalendarReset"
                size="XS"
                theme="fill_secondary"
                disabled={isResetDisabled}
                onClick={onResetClick}
              >
                Сбросить
              </Button>
            </div>
          </div>
        )}
      </BookingCalendarLayout>
    </Outside>
  );
};
